<template lang="pug">
  #makePictureIndex.d-flex.flex-column(
    style="height: calc(100% - 120px)"
  )
    .container-width.w-100(
      style="padding-bottom: 20px;flex: 1 1 0;",
    )
      #step1(v-if="nowStep == 1" @click="nowStep = 2")
        .mb-4.font-weight-bold.text-center
          p.d-block.mb-0 歡迎成為 TIFFANY & CO. 摯友 ！
          p.d-block.mb-0 請依照以下操作步驟製作您個人專屬的主題桌布
        img.img-fluid.w-100(:src="require(`@/assets/images/makePicture/instruct2.png`)")
      #step2.w-100(v-if="nowStep == 2")
        .selectWallPaperArea(v-show="!showCustomImage")
          .mb-4.font-weight-bold.text-center
            p.d-block.mb-0 請選擇一款主題桌布
          .wallpaperArea.position-relative.d-flex.align-items-center.w-100
            img.h-100(v-show="imageIndex !== 1" style="width: 10%; height:auto" :src="require(`@/assets/images/makePicture/leftClick.png`)" @click="changeImageIndex(-1)")
            div(v-show="imageIndex === 1" style="width: 10%;")
            img.img-fluid.h-100#previewWallPaper(width="80%" :src="require(`@/assets/images/makePicture/v2wallPaper${imageIndex}.png`)" @click="selectImage")
            img.h-100(v-show="imageIndex !== 3" style="width: 10%; height:auto" :src="require(`@/assets/images/makePicture/rightClick.png`)" @click="changeImageIndex(+1)")
            div(v-show="imageIndex === 3" style="width: 10%;")

        .showCustomImage.mx-3(v-show='showCustomImage')
          .remindText.text-center
            span 請選擇至多9個欲新增的圖案與文字元素

          #cre_img.cre_img.w-100
            .photo-frame(style='width: 100%; position: relative; overflow: hidden;')
              img#img_tmp.photo-frame-test.img-responsive(style='position: absolute; width:100%;')
            // sweetalert 的 z-index 為1060 需小於sweetalert
            .position-absolute#move_area(style="left: 10%; width: 80%; height: 80%; top: 10%")
              .moveIconArea.move.draggable(:id="`icon${index+1}`" v-for="(icon, index) in iconArr" style='position: absolute; top: 50px; left: 100px; color: black; font-size: 16px; z-index: 2; padding: 5px; border: 1px dashed #000000;')
                .move-arrow(style='position: absolute; top: -12px; left: -9px; color: #0a0a0a; cursor: move;')
                  i.fas.fa-times(style="font-size: 22px" @click='removeIcon(index + 1)')
                .trun-rignt-area(style='position: absolute; top: -12px; right: -9px; color: #0a0a0a; cursor: move;')
                  i.fas.fa-redo-alt(style="font-size: 22px" @click="turnIcon(index, 'plus')")
                .trun-rignt-area(style='position: absolute; bottom: -12px; left: -9px; color: #0a0a0a; cursor: move;')
                  i.fas.fa-undo-alt(style="font-size: 22px" @click="turnIcon(index, 'minus')")
                img(:style="{ height: icon.width + 'px', transform: `rotate(${icon.rotate}deg)`}" :src="require(`@/assets/images/makePicture/icon${icon.index}.png`)" @mouseup='changeSelectedIcon(index)')
            img#picture-frame.img-responsive.frame-size(:src="require(`@/assets/images/makePicture/v2wallPaper${imageIndex}.png`)" width='100%')

          .textSizeSettingArea.mt-3
            .col-xs-12
              .col-xs-12.text-left.d-flex(style="padding: 0;")
                | 圖案大小：
                .span#size {{ iconWidth }}
              .col-xs-12.text-left(style="padding: 5px;")
                #slider

          .text-center.mt-3.d-flex(v-if="showButton")
            .col-4(style="padding: 0 10px")
              button.btn.btn-primary(@click="showCustomImage = !showCustomImage") 選擇桌布
            .col-4(style="padding: 0 10px")
              button.btn.btn-primary(@click="showIcon = !showIcon") 選擇圖案
            .col-4(style="padding: 0 10px")
              button.btn.btn-primary(@click="finish()") 完成桌布

          .position-relative.w-100
            .position-fixed(v-show='showIcon' style="z-index: 999; bottom: 1vh; height: 40vh; width: 90%; left: 5%; border-radius: 10px; border: 1px solid; background-color: #FFF; overflow: scroll")
              i.fas.fa-times(style="position: relative; left: 90%; font-size: 30px;" @click="showIcon = !showIcon")
              .my-2.d-flex.flex-wrap.align-items-center
                div.my-2.text-center(style="width: 20%" v-for="i in 26")
                  img.icon1.px-1(style="max-width: 100%" :src="require(`@/assets/images/makePicture/icon${i}.png`)" @click="selectIcon(i)")
              .my-2.d-flex.flex-wrap.align-items-center
                div.my-2.text-center(style="width: 20%" v-for="i in 26")
                  img.icon.px-1(style="max-width: 100%" :src="require(`@/assets/images/makePicture/icon${i+26}.png`)" @click="selectIcon(i+26)")
              .my-2.d-flex.flex-wrap.align-items-center
                div.my-2.text-center(style="width: 20%" v-for="i in 13")
                  img.icon.px-1(style="max-width: 100%" :src="require(`@/assets/images/makePicture/icon${i+52}.png`)" @click="selectIcon(i+52)")
      #step3(v-if="nowStep == 3")
        .text-center
          span 您的專屬限定桌布已完成，請長按圖片進行下載
        .text-center.mt-3.d-flex(v-if="showCustomImage" style="padding: 0 10%")
          img.w-100(:src="finishedWallPaper")
</template>

<script>
import { mapState } from 'vuex';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import VerifyComponent from '@/components/verify/VerifyComponent.vue'; // 驗證套件
import $ from 'jquery';
import 'jquery-ui-dist/jquery-ui';
import 'jquery-ui-dist/jquery-ui.min.css';
import 'jquery-ui-touch-punch';
import html2canvas from 'html2canvas';

const _ = require('lodash');

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

// 客製化驗證套件
extend('verify', {
  validate: (val) => {
    if (VerifyComponent.data.varifyAnswer === undefined) return true;
    return val === VerifyComponent.data.varifyAnswer ? true : false;
  },
  message: '驗證碼錯誤'
});

export default {
  name: 'SignUpIndex',
  components: {
    ValidationProvider,
    ValidationObserver,
    VerifyComponent
  },
  props: {
    sa_id: {
      type: [String, Number],
      required: false
    },
    store_id: {
      type: [String, Number],
      required: false
    }
  },
  data() {
    return {
      nowStep: 1,
      imageIndex: 1,
      iconArr: [],
      showCustomImage: false, // 是否顯示選擇桌布
      finishedWallPaper: require('@/assets/images/makePicture/wallPaper1.png'),
      iconWidth: 100,
      isCreateIcon: false,
      nowSelectMoveIconIndex: 0,
      showIcon: false,
      iconNum: 0,
      showButton: false,
      line_uuid: null,
    };
  },
  created() {
    window.onload = () => {
      document.addEventListener('touchstart', (event) => {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      }, { passive: false });
      let lastTouchEnd = 0;
      document.addEventListener('touchend', (event) => {
        const now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      }, false);
    };
  },
  mounted() {
    const vm = this;
    // document.addEventListener('touchstart', function(e) {
    //   if (e.touches.length > 1) {
    //     e. preventDefault();
    //   }
    // });
    window.addEventListener('gesturestart', function (event) {
      event.preventDefault();
    });
    window.addEventListener('gesturechange', function (event) {
      event.preventDefault();
    });
    window.addEventListener('gestureend', function (event) {
      event.preventDefault();
    });
    // 檢查綁定狀態
    vm.$store.dispatch('member_bind_sa/checkMemberBindHandler')
      .then((res) => {
        if (res.type === 'not_binding') {
          vm.$router.push({
            name: 'm-sign-up'
          })
        } else {
          vm.line_uuid = res.line_uuid;
        }
        vm.$store.commit('toggleLoading', false);
      });
  },
  methods: {
    // 切換桌布
    changeImageIndex(num) {
      const vm = this;
      vm.imageIndex += num;
    },
    selectImage() {
      const vm = this;
      vm.showButton = false;
      vm.showCustomImage = true;
      // $('.move').hide();
      $('#move-arrow').draggable({ containment: '#move_area', scroll: false });
      setTimeout(() => {
        $('.photo-frame').height($('#picture-frame').height());
        $('.photo-frame').width($('#picture-frame').width());
        $('#slider').slider({
          value: vm.iconWidth,
          min: 50,
          max: 200,
          step: 1,
          slide: function( event, ui ) {
            vm.iconWidth = ui.value;
            if (vm.iconArr.length === 0) {
              return;
            }
            vm.iconArr[vm.nowSelectMoveIconIndex].width = ui.value;
          }
        });
        vm.showButton = true;
      }, 100);
    },
    selectIcon(i) {
      const vm = this;

      if (!vm.showCustomImage) return;
      // 等圖片更新後才能觸發下一次新增
      if (vm.isCreateIcon) return;
      vm.isCreateIcon = true;

      if (vm.iconNum === 9) {
        vm.$swal.fire({
          title: '已選擇9個圖案與文字元素',
          icon: 'info'
        });
        vm.isCreateIcon = false;
        return;
      }
      vm.iconArr.push(
        {
          index: i,
          width: vm.iconWidth,
          rotate: 0
        }
      );
      vm.iconNum += 1;
      setTimeout(() => {
        $(`#icon${ vm.iconArr.length}`).draggable({ containment: '#move_area', scroll: false });
        vm.nowSelectMoveIconIndex = vm.iconArr.length - 1;
        vm.showIcon = false;
        vm.isCreateIcon = false;
      }, 100);
    },
    finish() {
      const vm = this;
      vm.$store.dispatch('member_make_picture/sendClickRecordHandler', {line_uuid: vm.line_uuid, desktop_no: vm.imageIndex})
      vm.showIcon = false;
      // 拖拉移除外框
      $('.move').css('border', 0);
      // 拖拉浮標移除圖案
      $('.fa-times').addClass('d-none');
      $('.fa-redo-alt').addClass('d-none');
      $('.fa-undo-alt').addClass('d-none');
      html2canvas($('.cre_img')[0], {
        width: $('.cre_img').width(),
        height: $('.cre_img').height()
      }).then((canvas) => {
        vm.finishedWallPaper = canvas.toDataURL('image/jpeg');
        vm.nowStep += 1;
      });
    },
    changeIconWidthHandler(val) {
      const vm = this;
      vm.iconArr[vm.nowSelectMoveIconIndex].width = val;
    },
    changeSelectedIcon(index) {
      const vm = this;
      vm.nowSelectMoveIconIndex = index;
      vm.iconWidth = vm.iconArr[index].width;
      $('#slider').slider({
        value: vm.iconWidth,
      });
    },
    removeIcon(index) {
      const vm = this;
      $(`#icon${index}`).remove();
      vm.iconNum -= 1;
    },
    turnIcon(index, method) {
      const vm = this;
      method === 'plus' ? vm.iconArr[index].rotate += 10 : vm.iconArr[index].rotate -= 10;
    }
  },
  computed: {
    ...mapState({
      saInfo: (state) => state.member_bind_sa.saInfo
    })
  }
};
</script>

<style scoped>
  .cre_img{
    position: relative;
    background-color: #FFFFFF;
    margin-top: 5px !important;
  }

  .photo-frame {
    /*background-image: url("../assets/images/photo2.jpg");*/

    /* Full height */
    height: 100%;

    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn-group div {
    padding: 10px;
    color: #FFFFFF;
  }

  .input-item, .btn-group, .footer {
    margin: 10px 0px !important;
  }

  .footer input {
  }

  #datetimepicker4 {
    width: 90px;
  }

  #count {
    width: 50px;
  }

  .frame-size {
    position: absolute;
    top: 0;
    right: 0;
  }

  .color {
    width: 30px;
    height: 30px;
    border-radius: 10px;
  }

  .red {
    background-color: red;
    /*border-radius: 20px;*/
    display: inline-block;
    border: 1px solid #e0e0e0;
    cursor: pointer;
  }

  .black {
    background-color: black;
    /*border-radius: 20px;*/
    display: inline-block;
    border: 1px solid #e0e0e0;
    cursor: pointer;
  }

  .yellow {
    background-color: yellow;
    /*border-radius: 20px;*/
    display: inline-block;
    border: 1px solid #e0e0e0;
    cursor: pointer;
  }

  .white {
    background-color: white;
    /*border-radius: 20px;*/
    display: inline-block;
    border: 1px solid #e0e0e0;
    cursor: pointer;
  }

  .orange {
    background-color: #FF9900;
    /*border-radius: 20px;*/
    display: inline-block;
    border: 1px solid #e0e0e0;
    cursor: pointer;
  }

  .lime {
    background-color: #00FF00;
    /*border-radius: 20px;*/
    display: inline-block;
    border: 1px solid #e0e0e0;
    cursor: pointer;
  }

  .cyan {
    background-color: #00FFFF;
    /*border-radius: 20px;*/
    display: inline-block;
    border: 1px solid #e0e0e0;
    cursor: pointer;
  }

  .blue {
    background-color: #0000FF;
    /*border-radius: 20px;*/
    display: inline-block;
    border: 1px solid #e0e0e0;
    cursor: pointer;
  }

  .purple {
    background-color: #9900FF;
    /*border-radius: 20px;*/
    display: inline-block;
    border: 1px solid #e0e0e0;
    cursor: pointer;
  }

  .pink {
    background-color: #FF00FF;
    /*border-radius: 20px;*/
    display: inline-block;
    border: 1px solid #e0e0e0;
    cursor: pointer;
  }

  .btn-group div {
    padding: 15px;
    color: #FFFFFF;
  }

  .btn-group .btn-info {
    background-color: #000000;
    border-color: #eeeeee;
  }

  .btn.focus, .btn:focus, .btn:hover
  {
    color:#e0e0e0 !important; /* add here any color */
  }
  .btn-light.focus, .btn-light:focus, .btn-light:hover{
    color: #333333 !important;
  }

  /* The container must be positioned relative: */
  .custom-select {
    position: relative;
    font-family: Arial;
    height: inherit!important;
  }

  .custom-select select {
    display: none; /*hide original SELECT element: */
  }

  .select-selected {
    background-color: DodgerBlue;
  }

  /* Style the arrow inside the select element: */
  .select-selected:after {
    position: absolute;
    content: "";
    top: 14px;
    right: 10px;
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-color: #fff transparent transparent transparent;
  }

  /* Point the arrow upwards when the select box is open (active): */
  .select-selected.select-arrow-active:after {
    border-color: transparent transparent #fff transparent;
    top: 7px;
  }

  /* style the items (options), including the selected item: */
  .select-items div,.select-selected {
    color: #ffffff;
    padding: 8px 16px;
    border: 1px solid transparent;
    border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
    cursor: pointer;
  }

  /* Style items (options): */
  .select-items {
    position: absolute;
    background-color: #000000;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 99;
  }

  /* Hide the items when the select box is closed: */
  .select-hide {
    display: none;
  }

  .select-items div:hover, .same-as-selected {
    background-color: rgba(0, 0, 0, 0.1);
  }
  /* checkbox */
  /* Customize the label (the container) */
  .custom-checkbox {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .custom-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #eee;
  }

  /* On mouse-over, add a grey background color */
  .custom-checkbox:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .custom-checkbox input:checked ~ .checkmark {
    background-color: #FFFFFF;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .custom-checkbox input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .custom-checkbox .checkmark:after {
    left: 7px;
    top: 4px;
    width: 7px;
    height: 10px;
    border: solid black;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .icon1 {
    height: 35px;
  }

  .icon {
    height: 40px;
  }
</style>
